// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1LfpT","fileBtn":"File_fileBtn__3XwEB","closeBtn":"File_closeBtn__yNDKn","fileSelected":"File_fileSelected__1040Q","disabled":"File_disabled__QE9Z9"};